import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'loading-component',
  templateUrl: './loading.html',
  styleUrls: ['./loading.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent {

  constructor() { }

}
